var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { useRef, useEffect, useState } from 'react';
import t from 'prop-types';
import Recorte from './recorte';
import { is_touch_device } from '../../util';
var isTouchDevice = is_touch_device();
var ON_MOVE = isTouchDevice ? 'onTouchMove' : 'onMouseMove';
var ON_DOWN = isTouchDevice ? 'onTouchStart' : 'onMouseDown';
var ON_UP = isTouchDevice ? 'onTouchEnd' : 'onMouseUp';

function Cartulina(_ref) {
  var _eventos;

  var color = _ref.color,
      colorTransparente = _ref.colorTransparente,
      resolucion = _ref.resolucion,
      recortes = _ref.recortes,
      minRecorte = _ref.minRecorte,
      onNuevoRecorte = _ref.onNuevoRecorte,
      onRecortes = _ref.onRecortes;

  var _useState = useState(null),
      nuevoRecorte = _useState[0],
      setNuevoRecorte = _useState[1];

  var canvasRef = useRef(null);
  useEffect(function () {
    if (!canvasRef) {
      return;
    }

    var ctx = canvasRef.current.getContext("2d");
    ctx.globalCompositeOperation = 'source-over';
    ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
    drawCartulina(ctx);
    recortes.forEach(function (recorte) {
      return recortar(ctx, recorte);
    });

    if (nuevoRecorte !== null) {
      recortar(ctx, nuevoRecorte);
    }
  });

  function toCanvasH(x) {
    return x * canvasRef.current.width / 100;
  }

  function toCanvasV(y) {
    return y * canvasRef.current.height / 100;
  }

  function drawCartulina(ctx) {
    var _canvasRef$current = canvasRef.current,
        width = _canvasRef$current.width,
        height = _canvasRef$current.height;
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(width, 0);
    ctx.lineTo(width, height);
    ctx.lineTo(0, height);
    ctx.lineTo(0, 0);
    ctx.closePath();
    ctx.fillStyle = nuevoRecorte || recortes.length === 0 ? colorTransparente : color; // ctx.strokeStyle= "rgba(0.5, 0.5, 0.5, 0.5)"

    ctx.lineWidth = 0;
    ctx.fill(); // ctx.stroke()
  }

  function recortar(ctx, _ref2) {
    var x = _ref2.x,
        y = _ref2.y,
        w = _ref2.w,
        h = _ref2.h;
    ctx.globalCompositeOperation = 'destination-out';
    ctx.beginPath();
    ctx.moveTo(toCanvasH(x), toCanvasV(y));
    ctx.lineTo(toCanvasH(x), toCanvasV(y + h));
    ctx.lineTo(toCanvasH(x + w), toCanvasV(y + h));
    ctx.lineTo(toCanvasH(x + w), toCanvasV(y));
    ctx.lineTo(toCanvasH(x), toCanvasV(y));
    ctx.closePath();
    ctx.fill();
  }

  function getCursorPosInCanvasUnits(e) {
    var rect = canvasRef.current.getBoundingClientRect();

    var _ref3 = e.changedTouches ? e.changedTouches[0] : e,
        clientX = _ref3.clientX,
        clientY = _ref3.clientY;

    return {
      left: 100 * (clientX - rect.left) / rect.width,
      top: 100 * (clientY - rect.top) / rect.height
    };
  }

  function handleMouseMove(e) {
    if (nuevoRecorte === null) {
      return;
    }

    var _getCursorPosInCanvas = getCursorPosInCanvasUnits(e),
        left = _getCursorPosInCanvas.left,
        top = _getCursorPosInCanvas.top;

    setNuevoRecorte(_extends({}, nuevoRecorte, {
      w: left - nuevoRecorte.x,
      h: top - nuevoRecorte.y
    }));
  }

  function handleMouseUp(e) {
    if (nuevoRecorte === null) {
      return;
    }

    if (Math.abs(nuevoRecorte.w) >= minRecorte.w && Math.abs(nuevoRecorte.h) >= minRecorte.h) {
      onNuevoRecorte(nuevoRecorte);
    }

    setNuevoRecorte(null);
  }

  function handleMouseDown(e) {
    if (nuevoRecorte !== null) {
      return;
    }

    var _getCursorPosInCanvas2 = getCursorPosInCanvasUnits(e),
        left = _getCursorPosInCanvas2.left,
        top = _getCursorPosInCanvas2.top;

    var recorte = {
      x: left,
      y: top,
      w: 1,
      h: 1
    };
    setNuevoRecorte(recorte);
  }

  function handleEliminarRecorte(recorteIndex) {
    onRecortes(recortes.filter(function (_, index) {
      return index !== recorteIndex;
    }));
  }

  var eventos = (_eventos = {}, _eventos[ON_DOWN] = handleMouseDown, _eventos[ON_MOVE] = handleMouseMove, _eventos[ON_UP] = handleMouseUp, _eventos);
  return React.createElement('div', null, React.createElement('canvas', _extends({
    width: resolucion.width,
    height: resolucion.height,
    ref: canvasRef,
    style: {
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
      pointerEvents: 'initial'
    }
  }, eventos)), nuevoRecorte === null && recortes.map(function (_ref4, index) {
    var x = _ref4.x,
        y = _ref4.y,
        w = _ref4.w,
        h = _ref4.h;
    return React.createElement(Recorte, {
      key: 'recorte-' + index,
      index: index,
      x: x,
      y: y,
      w: w,
      h: h,
      onEliminar: handleEliminarRecorte
    });
  }));
}

Cartulina.propTypes = process.env.NODE_ENV !== "production" ? {
  /* color del fondo de la cartulina */
  color: t.string,

  /** color del fondo de la cartulina cuando no hay recortes 
   *  y tambien mientras se esta creanto un recorte */
  colorTransparente: t.string,
  resolucion: t.object,
  recortes: t.array,
  minRecorte: t.object,
  onNuevoRecorte: t.func,
  onRecortes: t.func
} : {};
export default Cartulina;